/*
Defines the custom element <ravel-v-stream>
*/

import { RavelVStream } from './src/RavelVStream.js';

customElements.define('ravel-v-stream', RavelVStream);
